import { render } from "./UnregisterReception.vue?vue&type=template&id=71605402"
import script from "./UnregisterReception.vue?vue&type=script&lang=js"
export * from "./UnregisterReception.vue?vue&type=script&lang=js"

import "./UnregisterReception.vue?vue&type=style&index=0&id=71605402&lang=css"
script.render = render

export default script